<form [formGroup]="form">
  <div class="fields-container">
    <div class="field-control">
      <app-option-field
        [label]="'MYSTERY_SHOPPER.PACKAGE_TYPE' | translate"
        [options]="packagesList"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [control]="form.get('packageType')!"
        (onSelectionChange)="onPackageTypeChange($event)"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.BRANCHES' | translate"
        [control]="form.get('branches')!"
        [maxlength]="3"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.CHANNELS' | translate"
        [control]="form.get('channels')!"
        [maxlength]="3"
      />
    </div>
    <div class="field-control">
      <app-option-field
        [label]="'MYSTERY_SHOPPER.QUARTER_TYPE' | translate"
        [options]="quarters"
        [labelKey]="'Value'"
        [valueKey]="'Value'"
        [control]="form.get('quartersType')!"
        [isMultiple]="true"
        (onSelectionChange)="onQuartersTypeChange($event)"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [type]="'number'"
        [label]="'MYSTERY_SHOPPER.QUARTERS' | translate"
        [control]="form.get('quarters')!"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.UNIT_PRICE' | translate"
        [control]="form.get('unitPrice')!"
        [maxlength]="10"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.VAT_AMOUNT' | translate"
        [control]="form.get('vatAmount')!"
        [maxlength]="10"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.TOTAL_AMOUNT' | translate"
        [control]="form.get('totalAmount')!"
        [maxlength]="10"
      />
    </div>
    <div class="field-control">
      <app-text-field
        [label]="'MYSTERY_SHOPPER.TOTAL_VAT_AMOUNT' | translate"
        [control]="form.get('totalVatAmount')!"
        [maxlength]="10"
      />
    </div>
  </div>

  @if (duplicatePackageTypeError) {
  <div class="fields-error-container">
    <app-validation-message
      [type]="'error'"
      [content]="{
        title: 'VALIDATION_MSG.ERROR' | translate,
        message: 'TOAST_MESSAGES.DUPLICATE_PACKAGE_TYPE' | translate
      }"
      [showbutton]="false"
    ></app-validation-message>
  </div>
  }

  <div class="btn-section buttons-group mt-4">
    <app-button
      classesName="btn-edge-cut btn-width-auto"
      [label]="
        isEdit
          ? ('MYSTERY_SHOPPER.UPDATE_PACKAGE' | translate)
          : ('MYSTERY_SHOPPER.SAVE_PACKAGE' | translate)
      "
      (onBtnClick)="onSave()"
    />
    <app-button
      classesName="card-edge-cut-white btn-width-auto"
      [label]="'BUTTONS.CANCEL' | translate"
      (onBtnClick)="onCancel()"
    />
  </div>
</form>
